import React from 'react'
import TabsTemplate from '../../../../templates/components/TabsTemplate'
import ProviderTableSettings from './provider-table-settings/ProviderTableSettings'
import LocationProviders from './location-providers/LocationProviders'

const ProviderSettings = (props) => {
    return (
        <TabsTemplate id="providerSettings" accordionId="providerSettings">
            <div title='Practice Providers'>
                <ProviderTableSettings/>
            </div>
            <div title='Location Providers'>
                <LocationProviders/>
            </div>
        </TabsTemplate>
    )
}

export default ProviderSettings